const campoRules = [
    v => !!v || "Campo Obrigatório!"
]


export { campoRules }
